import { render } from "./SignatureField.vue?vue&type=template&id=a19b7f76"
import script from "./SignatureField.vue?vue&type=script&lang=js"
export * from "./SignatureField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__